import {PAYMENT_TYPE} from '../../../CodeMaster'
import {Nullable} from '../../../app/TypeHelpers'
import {PaymentItemForViewFacility} from './PaymentItemForViewFacility'

export class PaymentItemForViewOvernight extends PaymentItemForViewFacility {
    private readonly stayCount: number

    constructor(paymentType: PAYMENT_TYPE, charge: Nullable<number>, stayCount: number) {
        super(paymentType, charge)
        this.stayCount = stayCount
    }

    quantityWithUnit(): string {
        return `${(this.stayCount)}泊`
    }
}
